// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1GDrO","content":"RecentSearches_content__16LSL"};